import type { ConfigType } from '@plone/registry';
import { UNIDADE_ROOTS } from 'volto-ministerio-publico-federal/helpers';

export const updateApiExpanders = (config: ConfigType) => {
  const newApiExpanders = [
    ...config.settings.apiExpanders,
    {
      match: '',
      GET_CONTENT: [
        'breadcrumbs',
        // Nome do adapter no backend (`services/components/footer`), não a
        // chave que ele devolve (`footerPortal`): o plone.restapi decide o que
        // expandir pelo nome do registro. Com a chave, o expander nunca
        // expandia e o rodapé caía na chamada avulsa `@portal-footer-info`.
        'portal-footer-info',
        'navigation',
        // Sem isto o SSR não sabe se a página tem sidebar: o dado dos slots
        // só chegava pelo fetch avulso de `@slots`, disparado no
        // componentDidMount. A página era renderizada no servidor sempre como
        // "sem sidebar" e corrigida depois da hidratação.
        'slots',
        // Conteúdo do item padrão da pasta. O `default_page` do serializer traz
        // só o ID; o View.jsx buscava o resto num fetch no componentDidUpdate,
        // que não roda no servidor — e o render retornava o estado de
        // carregamento ANTES das meta tags. Resultado: toda pasta com item
        // padrão (a home inclusive) era servida com <title> vazio, sem
        // description/canonical/Open Graph e com o corpo vazio.
        'default-page-content',
        // Assinatura da unidade de origem da notícia. O expander só está
        // registrado para Notícia (`INoticiaMeta`), então em qualquer outro
        // tipo isto não custa nada — e vale para notícia publicada fora da
        // árvore da unidade, em `/comunicacao/noticias`.
        'assinatura',
      ],
      // O adapter de navegação usa depth=1 por padrão; sem isto o mega menu
      // perderia da segunda coluna em diante — em silêncio, porque o fetch
      // avulso de fallback (`getNavigation`) só dispara quando o expander NÃO
      // vem. A profundidade que o painel exige está em `settings.navDepth`.
      querystring: (config: ConfigType) => ({
        'expand.navigation.depth': config.settings.navDepth,
      }),
    },
    // Contato/endereço/como chegar da unidade: a página de contato é um
    // Folder vazio (`contato_view`) e os dados moram no Locations pai — o
    // expander sobe a árvore sozinho. Vindo no GET_CONTENT, a tela já sai
    // pronta do SSR, sem o flash de um fetch avulso depois da hidratação.
    //
    // Uma entrada por ramo: `match` é um path do react-router, casado sem
    // `exact`, então cobre a subárvore inteira — vale para a unidade solta
    // (`/o-mpf/unidades/pr-sp`) e para a aninhada
    // (`/o-mpf/estrutura/procuradorias-regionais/prr6`).
    ...UNIDADE_ROOTS.map((root) => ({
      match: root,
      GET_CONTENT: ['contato'],
    })),
  ];

  config.settings.apiExpanders = newApiExpanders;

  return config;
};

export default updateApiExpanders;
